<template>
  <generic-modal
    size
    :title="$t('instance manager')"
    icon="settings"
    image="/images/icons/process.png"
    v-on:destroy="destroy"
    :scrolling="true"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui three item top attached tabular menu">
        <a class="active item" data-tab="minstance">{{ $t("instance") }}</a>
        <a class="item" data-tab="minteraction">{{ $t("interaction") }}</a>
        <a class="item" data-tab="mhuman_task">{{ $t("human task") }}</a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="minstance">
        <pre>{{ inst.payload }}</pre>
      </div>
      <interaction
        class="ui bottom attached tab segment"
        data-tab="minteraction"
        :interaction="inte"
      />
      <div class="ui bottom attached tab segment" data-tab="mhuman_task">
        <pre>{{ huta }}</pre>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { local_api, stringify } from "@/utils";
import { v4 } from "uuid";
import { cloneDeep } from "lodash";
import Interaction from "./Interaction.vue";

export default {
  name: "NgineInstanceManagerModal",
  components: {
    "generic-modal": GenericModal,
    Interaction,
  },
  computed: {
    inst() {
      let i = cloneDeep(this.instance);
      if (i) {
        i.last_interaction = undefined;
        if (i.payload) i.payload = JSON.parse(i.payload);
        delete i.process_definitions;
        return i;
      } else return "";
    },
    inte() {
      if (this.instance) {
        let i = cloneDeep(this.instance.last_interaction);
        if (i) {
          i.ngn_user_tasks = undefined;
          if (i.component) i.component = JSON.parse(i.component);
          if (i.ngn_user_task && i.ngn_user_task.setup)
            i.ngn_user_task.setup = JSON.parse(i.ngn_user_task.setup);
          return i;
        } else return {};
      } else return {};
    },
    huta() {
      if (
        this.instance &&
        this.instance.last_interaction &&
        this.instance.last_interaction.ngn_user_tasks &&
        this.instance.last_interaction.ngn_user_tasks.length
      ) {
        let i = this.instance.last_interaction.ngn_user_tasks.find((n) => n);
        return i;
      } else return "";
    },
  },
  props: { instance_id: String },
  data() {
    return {
      instance: undefined,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let process = {
            uuid: vm.$props.process.uuid || v4(),
            public_uuid: v4() + "-" + v4(),
            name: vm.name,
            description: vm.description,
          };
          vm.$emit("succedded", process);
          resolve();
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    setTimeout(() => {
      window.jQuery(".tabular.menu .item").tab();
    }, 300);
  },
  watch: {},
  created() {
    let vm = this;
    local_api(vm, "post", "/ngine_core/instance/do-get-info", {
      i: vm.instance_id,
    })
      .then((instance) => {
        vm.instance = instance;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
};
</script>
